<div class="forms-offset-wrapper" [ngClass]="{'-top-offset': topOffset, '-modal-offset': modalOffset}">
    <div class="forms-offset-wrapper__inner">

        <div class="forms-offset-wrapper__col -left" *ngIf="left">
            <ng-container *ngTemplateOutlet="left"></ng-container>
        </div>

        <div class="forms-offset-wrapper__col -right" *ngIf="right">
            <ng-container *ngTemplateOutlet="right"></ng-container>
        </div>

    </div>
</div>